import { render, staticRenderFns } from "./SiteHeader.vue?vue&type=template&id=dd37d258&lang=pug&"
import script from "./SiteHeader.vue?vue&type=script&lang=ts&"
export * from "./SiteHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports